import { Button } from "antd";
import { useDesactivarCodigoPokemon } from "../../../../Hooks/Admin";
import { useQueryClient } from "react-query";




const DesactivarButton = ({ idCodigo, estado }) => {
    const apiDesactivar = useDesactivarCodigoPokemon();
    const queryClient = useQueryClient()
    return (
      <Button
        type="primary"
        danger
        disabled={estado === "Desactivado"} 
        onClick={async () => {
          try {
           
            const response = await apiDesactivar.mutateAsync({ idCodigo });
  
     
  
            if (response?.success) {
              //alert("Código desactivado correctamente");
              queryClient.invalidateQueries("listarCuponesPokemones");
              window.location.reload()
            } else {
              throw new Error(response?.message || "Error desconocido");
            }
          } catch (error) {
            console.error("Error:", error);
            alert("Hubo un problema al desactivar el código");
          }
        }}
      >
        Desactivar Código
      </Button>
    );
};


export const columns = [
  {
    title: "Codigo",
    dataIndex: "codigo",
    width: "20%",
  },
  {
    title: "Cantidad",
    dataIndex: "objeArray",
    width: "5%",
    render: (cantidad) => {
        const parsedArray = JSON.parse(cantidad); 
        const totalCantidad = parsedArray.length; 
    
        return <div>{totalCantidad}</div>;
      },
    
  },
  {
    title: "Grado",
    dataIndex: "nombreGrado",
    width: "20%",
  },
  {
    title: "Estado",
    dataIndex: "estado",
    width: "10%",
    render: (estado) => {
        const color = estado === "Activo" ? "green" : "red";
        return (
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <div
              style={{
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                backgroundColor: color,
              }}
            />
            {estado}
          </div>
        );
      },
  },
  {
    title: "Fecha Creación",
    dataIndex: "fechaCreacion",
    width: "30%",
    render: (fecha) => {
        if (!fecha) return "-"; 
        const fechaObj = new Date(fecha);
        return fechaObj.toLocaleDateString("es-ES", {
          year: "numeric",
          month: "long",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        });
      },
  },

  {
    title: "Desactivar",
    dataIndex: "idCodigo",
    width: "5%",
    render:(_, record) => <DesactivarButton idCodigo={record.idCodigo} estado={record.estado} />,
   
  },
];
export const formatData = (data) => {
  return {
    idZona: data.idZona,
    zona_nombre: data.nombre,
    zona_imagen: data.imagen,
    nombre: data.nombre,
    imagen: data.imagen,
    pokemones: [],
  };
};

export const camposFormulario = ({objetos = [], grados = []}) => {
 return {
    
    title: "Codigos Objetos",
  campos: [
    {
      name: "cantidad",
      label: "Cantidad",
      type: "number",
      max: 10,
      min: 1,
      rules: [
        {
          required: true,
          message: "La cantidad es obligatoria",
        },
      ],
      
    },
    {
        name: "grado",
        label: "Grado (Selecciona un grado para omitir la lista de objetos)",
        type: "autocomplete",
        opciones: grados,
    },
    {
      name: "items",
      label: "Objetos",
      type: "multiple",
      opciones: objetos,
    },
  ],
}};

export const camposFilter = {
  title: "Codigos Objetos",
  campos: [
    {
      name: "disponible",
      type: "checkbox",
      label: "Listar todos",
      valuePropName: "checked",
    },
  ],
};
